import React, { useEffect } from "react";

const CoinMarqueeWidget: React.FC = () => {
  useEffect(() => {
    const container = document.getElementById("coinmarket-widget");

    // Clean old widget scripts (if hot reloading)
    if (container) {
      container.innerHTML = "";
    }

    // Create the script tag for CoinMarketCap
    const script = document.createElement("script");
    script.src = "https://files.coinmarketcap.com/static/widget/coinMarquee.js";
    script.type = "text/javascript";
    script.async = true;

    // Configure the widget using data attributes
    const div = document.createElement("div");
    div.id = "coinmarketcap-widget-marquee";
    div.setAttribute("coins", "1,1027,825,3408,1839,5426,74,5805"); // example coins
    div.setAttribute("currency", "USD");
    div.setAttribute("theme", "light");
    div.setAttribute("transparent", "false");
    div.setAttribute("show-symbol-logo", "true");

    // Append the new widget div
    if (container) {
      container.appendChild(div);
      container.appendChild(script);
    }
  }, []);

  return (
    <div className="container mx-auto px-4 md:px-6 mt-10">
      <div className="flex justify-center mb-10 ">
        <div className="relative w-full max-w-[160px] sm:max-w-[180px] md:max-w-[300px]">
          <iframe
            src="https://app.rwa.io/embed/verification-project-badge/bingold?theme=light"
            className="w-full h-15 sm:h-11 md:h-30 rounded-lg shadow-md"
            frameBorder="0"
            scrolling="no"
            title="Bingold Verification Badge"
          />
        </div>
      </div>

      <div id="coinmarket-widget" className="mt-4 mb-14" />
    </div>
  );
};

export default CoinMarqueeWidget;
